import * as Styled from './style';

type ToolBoxProps = {
    header: React.ReactNode;
    children: React.ReactNode;
}

export function ToolBox ({ header, children } : ToolBoxProps) {
    return (
        <Styled.IntersectBox>
            <Styled.IntersectHeader>
                {header}
            </Styled.IntersectHeader>
            {children}
        </Styled.IntersectBox>
    )
}